import { AuthenticationFacade } from '../auth';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  private URL_FRAGMENTS_WITHOUT_AUTH = [
    './',
    'res/api/file',
    'res/api/data/passwordoptions',
    'res/api/utils',
    'isHealthy',
    '.well-known',
    'auth/connect',
  ];
  private auth = inject(AuthenticationFacade);

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const requestRequiresToken = this.requestRequiresToken(request);
    if (!requestRequiresToken) {
      return next.handle(request);
    }

    return from(this.auth.getAccessToken()).pipe(
      switchMap((authToken) => {
        const authReq = request.clone({
          setHeaders: {
            Authorization: `Bearer ${authToken}`,
          },
        });
        return next.handle(authReq);
      }),
    );
  }

  private requestRequiresToken(req: HttpRequest<unknown>): boolean {
    return !this.URL_FRAGMENTS_WITHOUT_AUTH.some((token) => req.url.includes(token));
  }
}
